import { createContext } from "react";

const WallpaperContext = createContext();

export default WallpaperContext;
